import React from 'react';

import type { DocumentMedia as DocumentMediaType } from 'modules/medias/types/document-media';

import type { MediaGalleryActions, MediaListItem } from '../../types';
import Actions from '../Actions';
import { DocumentIcon } from '../UI';

import Restrict from './Restrict';

type DocumentMediaProps = {
  media: MediaListItem<DocumentMediaType>;
} & MediaGalleryActions;

const DocumentMedia: React.FC<DocumentMediaProps> = ({ media, onRestrict, disabledOnRestrict, ...actions }) => {
  const { onPreview } = actions;
  const { isDuplicated } = media.data;
  const extension = media.data.filename?.split('.').pop();

  const handleOnClick = React.useCallback(() => {
    onPreview?.(media);
  }, [media, onPreview]);

  return (
    <React.Fragment>
      <DocumentIcon
        extension={extension}
        onClick={handleOnClick}
        className="w-100 cursor-pointer"
        data-cy="media-gallery-tile"
      />
      {!isDuplicated && onRestrict && (
        <Restrict media={media} onRestrict={onRestrict} disabled={disabledOnRestrict} />
      )}
      <Actions media={media} {...actions} />
    </React.Fragment>
  );
};

export default DocumentMedia;
